if (document.querySelector(".categories-track")) {
  document.addEventListener("DOMContentLoaded", function () {
    let track = document.querySelector(".categories-track");
    let items = document.querySelectorAll(".categories-item");

    // Duplicate items to create a seamless loop
    items.forEach((item) => {
      let clone = item.cloneNode(true);
      track.appendChild(clone);
    });

    let totalWidth = track.scrollWidth / 2; // Calculate original width

    const marquee = gsap.to(track, {
      x: -totalWidth,
      duration: 25,
      ease: "none", // "none" is preferred for linear motion in GSAP 3+
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % -totalWidth),
      },
    });

    // Pause/resume on hover
    track.addEventListener("mouseenter", () => marquee.pause());
    track.addEventListener("mouseleave", () => marquee.resume());
  });
}

if (document.querySelector(".product-slider")) {
  const productSlider = new Swiper(".product-slider", {
    slidesPerView: 1.5,
    loop: true,
    spaceBetween: 8,
    breakpoints: {
      768: {
        slidesPerView: 2.6,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 8,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".tab-btns .brand-button-next",
      prevEl: ".tab-btns .brand-button-prev",
    },
  });
}

for (let i = 1; i < 5; i++) {
  if (document.querySelector(".product-slider" + i)) {
    new Swiper(".product-slider" + i, {
      slidesPerView: 1.5,
      loop: true,
      spaceBetween: 8,
      breakpoints: {
        768: {
          slidesPerView: 2.6,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 8,
        },
      },
      // Navigation arrows
      navigation: {
        nextEl: ".tab-btns-" + i + " .brand-button-next",
        prevEl: ".tab-btns-" + i + " .brand-button-prev",
      },
    });
  }
}

if (document.querySelector(".product-action-slider")) {
  new Swiper(".product-action-slider", {
    // Optional parameters
    slidesPerView: 1.8,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 8,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".product-action-button-next",
      prevEl: ".product-action-button-prev",
    },
  });
}

if (document.querySelector(".blog-action-slider")) {
  const productActionSlider = new Swiper(".blog-action-slider", {
    // Optional parameters
    slidesPerView: 1.8,
    spaceBetween: 16,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 8,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".blog-action-slider~.brand-button-next",
      prevEl: ".blog-action-slider~.brand-button-prev",
    },
  });
}

if (document.querySelector(".inspiration-slider")) {
  new Swiper(".inspiration-slider", {
    // Optional parameters
    slidesPerView: 1.7,
    spaceBetween: 8,
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 35,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".inspiration-button-next",
      prevEl: ".inspiration-button-prev",
    },
  });
}

if (document.querySelector(".product-detail-slider")) {
  const productThumbSlider = new Swiper(".product-thumb-slider", {
    direction: "horizontal",
    slidesPerView: "auto",
    loop: true,
    spaceBetween: 12,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      576: {
        direction: "vertical",
      },
    },
  });

  new Swiper(".product-detail-slider", {
    loop: true,
    spaceBetween: 24,
    slidesPerView: 1,
    //centeredSlides: true,
    thumbs: {
      swiper: productThumbSlider,
    },
  });
}

if (document.querySelector(".rating-slider")) {
  new Swiper(".rating-slider", {
    // Optional parameters
    slidesPerView: 1.5,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".rating-button-next",
      prevEl: ".rating-button-prev",
    },
  });
}

if (document.querySelector(".tab-slider")) {
  new Swiper(".tab-slider", {
    slidesPerView: "auto",
    spaceBetween: 32,
  });
}

if (document.querySelector(".collection-slider")) {
  new Swiper(".collection-slider", {
    slidesPerView: "auto",
    spaceBetween: 16,
    breakpoints: {
      768: {
        spaceBetween: 38,
      },
    },
    navigation: {
      nextEl: ".collection-button-next",
      prevEl: ".collection-button-prev",
    },
  });
}

if (document.querySelector(".trending-slider")) {
  new Swiper(".trending-slider", {
    // Optional parameters
    slidesPerView: 2,
    spaceBetween: 8,
    breakpoints: {
      576: {
        slidesPerView: 3,
        spaceBetween: 8,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 8,
      },
    },
    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },
  });
}

if (document.querySelector(".popular-brand-slider")) {
  new Swiper(".popular-brand-slider", {
    // Optional parameters
    slidesPerView: 3,
    spaceBetween: 8,
    breakpoints: {
      576: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 6,
      },
      1366: {
        slidesPerView: 8,
      },
    },
    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },
  });
}

// Home Page slider
if (document.querySelector(".DRS_hero_section")) {
  var HeroSwiper = new Swiper(".DRS_hero_section", {
    spaceBetween: 0,
    rewind: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

if (document.querySelector(".ma-promo-swiper.swiper .swiper-container")) {
  var swiper = new Swiper(".ma-promo-swiper.swiper .swiper-container", {
    slidesPerView: 2,
    slidesPerGroup: 1,
    spaceBetween: 10,
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        navigation: false,
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        navigation: {
          nextEl: ".ma-promo-swiper .swiper-button-cnext",
          prevEl: ".ma-promo-swiper .swiper-button-cprev",
        },
      },
    },
  });
}
